import { Box, Grid, Typography } from '@mui/material';
import { generatePublicUrlForFileInAWSS3Bucket } from '../../services/uploadFileOnAWS_S3_Bucket';

const EntertainementEntityList = ({ entertainment_entity_data,setEntertainmentEntity,handleCreateUpdateClick }) => {

    const GridItem = ({item}) => {
       var imageUrl = item?.displayImage ? item?.displayImage : (generatePublicUrlForFileInAWSS3Bucket(item?.multimedia?.[0]?.url) || generatePublicUrlForFileInAWSS3Bucket(item?.multimediaV2?.[0]?.url) || generatePublicUrlForFileInAWSS3Bucket(item?.image));
       console.log("Generated Image URL:", imageUrl);
        return (
            <Grid>
                <Box
                    sx={{
                        position: 'relative',
                        height: 140,
                        width: 240,
                        borderRadius: 2,
                        overflow: 'hidden',
                        //backgroundImage: `url(${item.multimedia.url})`,
                        backgroundColor: 'whitesmoke',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        padding: 1,
                        border: '1px solid #ccc',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={() => {
                        // if (item?.multimedia) {
                        //   setSelectedEntertainmentEntity(item);
                        //   //setOpenMediaDialog(true);
                        // }
                    }}
                >
                    {/* Image thumbnail */}
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: 2,
                            overflow: 'hidden',
                            backgroundImage: `url(${imageUrl})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            mr: 2,
                            flexShrink: 0,
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        onClick={() => {
                            // if (item?.multimedia) {
                            //     //setSelectedEntertainmentEntity(item);
                            //     //setOpenMediaDialog(true);
                            //     //setOpenMediaDialog(true);
                                
                            //     //handleCreateUpdateClick(item);
                            // }
                            handleCreateUpdateClick(item);
                        }}
                    />

                    {/* Info area */}
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                            {item?.displayName}
                        </Typography>
                        {/* <Typography variant="body2" noWrap>
                            {item?.genres?.join(', ') || 'N/A'}
                        </Typography> */}
                        <Typography variant="caption" color="text.secondary">
                            {item?.type}
                        </Typography>
                    </Box>

                </Box>
            </Grid>
        );
    }
    return (
        <Box sx={{ m: 0, p: 2, height: '100%', width: '100%' }}>

            <Grid container spacing={2}
                sx={{
                    width: '100%',
                    paddingBottom:2
                }}
            >
                {entertainment_entity_data?.map((item) => (
                  <GridItem key={item?._id} item={item}/>
                ))}
            </Grid>
        </Box>

    )
}

export default EntertainementEntityList
